import type { CompassPreviewCache } from '$/requests/GovernanceCheck.ts';

type LedgerEntryLike = { step: string; payload: unknown };

type RecommendationLedgerPayload = {
  commitment_confidence?: number;
  primary_assumption?: string;
};

export type ResolvedSessionCommitment = {
  confidence: number;
  assumption: string;
};

function fromLedgerPayload(payload: RecommendationLedgerPayload | null): ResolvedSessionCommitment | null {
  const assumption = payload?.primary_assumption?.trim();
  const confidence = payload?.commitment_confidence;
  if (!assumption || confidence == null || confidence < 1 || confidence > 5) return null;
  return { confidence, assumption };
}

function fromCompassCache(cache: CompassPreviewCache | null | undefined): ResolvedSessionCommitment | null {
  const inputs = cache?.inputs;
  if (!inputs) return null;
  const assumption = inputs.primary_assumption?.trim();
  const confidence = inputs.commitment_confidence;
  if (!assumption || confidence < 1 || confidence > 5) return null;
  return { confidence, assumption };
}

/** Story 7: ledger seal first; fallback to decision.compass_preview_cache for pre-fix escalations. */
export function resolveSessionCommitment(
  ledgerEntries: LedgerEntryLike[],
  compassPreviewCache: CompassPreviewCache | null | undefined,
): ResolvedSessionCommitment | null {
  const recommendationEntry = ledgerEntries.find((e) => e.step === 'recommendation');
  const fromLedger = fromLedgerPayload(
    (recommendationEntry?.payload as RecommendationLedgerPayload | undefined) ?? null,
  );
  if (fromLedger) return fromLedger;
  return fromCompassCache(compassPreviewCache);
}
